module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/147.2d490b44.png";